export default __webpack_public_path__ + "static/media/tokensBg2.ac2f7526.png";